import { IconButton, IconButtonTypes, Tooltip, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';
import { EquityOrderCancel } from '../EquityOrderCancel';
import { useCancelOrder } from '../EquityOrderCancel/hooks/cancel';
import { OrderEntityWithEvents } from '../OrderDetails/constants';

interface EquityExecutionActionsProps {
  data?: OrderEntityWithEvents;
}

interface ActionButtonProps extends IconButtonTypes.Props {
  title: string;
  hideTooltip: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  title,
  iconColor,
  icon,
  hideTooltip,
  ...rest
}) => {
  return (
    <Tooltip label={title} hasArrow {...(hideTooltip && { display: 'none' })}>
      <VStack>
        <IconButton
          borderRadius={BoxRadius.sm}
          w="40px"
          h="40px"
          iconColor={iconColor}
          icon={icon}
          iconSize="xxs"
          {...rest}
          {...(rest.isDisabled && {
            iconColor: Color['neutral.white'],
            bg: Color['neutral.light'],
          })}
        />
      </VStack>
    </Tooltip>
  );
};

export const EquityExecutionActions: React.FC<EquityExecutionActionsProps> = ({ data }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { handleCancelEquityOrder, cancelOrderModalIsOpen, handleChangeCancelOrderModalState } =
    useCancelOrder({ orderId: data?.orderId! });

  return (
    <>
      <HStack
        space={Spacing['inline.xxxs']}
        alignItems="center"
        {...(isMobile && {
          flex: 1,
          alignItems: 'center',
          justifyContent: 'space-between',
        })}>
        <ActionButton
          testId="action-button-edit"
          bg={Color['brand.tertiary.principal']}
          iconColor={Color['neutral.white']}
          isDisabled={!data?.isEditable}
          icon="EditPen"
          onPress={() => navigate('EquityOrderEdit', { data })}
          title="Editar ordem"
          hideTooltip={cancelOrderModalIsOpen}
        />
        <ActionButton
          testId="action-button-cancel"
          onPress={() => handleChangeCancelOrderModalState(true)}
          iconColor={Color['feedback.error.default']}
          bg={Color['feedback.error.lightest']}
          icon="Cancel"
          isDisabled={!data?.isEditable}
          title="Cancelar ordem"
          hideTooltip={cancelOrderModalIsOpen}
        />
      </HStack>
      <EquityOrderCancel
        data={data}
        onCancel={handleCancelEquityOrder}
        isOpen={cancelOrderModalIsOpen}
        onClose={() => handleChangeCancelOrderModalState(false)}
      />
    </>
  );
};
